import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
import { z } from 'zod';
import { runInBackground } from '@anchorbase/pillar-sdk';

const MonetaryAmountSchema = z.union([z.number(), z.string()]);

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}

export { runInBackground };

export function formatMonetaryAmount(amount: string | number, currencyCode: string = 'USD'): string {
    const parseResult = MonetaryAmountSchema.safeParse(amount);
    if (!parseResult.success) {
        throw new Error(`Invalid monetary amount: ${String(amount)}`);
    }
    const numericAmount: number = Number(parseResult.data);
    if (!Number.isFinite(numericAmount)) {
        throw new Error(`Invalid monetary amount: ${String(amount)}`);
    }
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currencyCode,
    }).format(numericAmount);
}
